<template>
  <div class="modal fade" id="manageSubjectStudentsModal">
    <div class="modal-dialog" role="document">
      <div v-if="Subject != null" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ Subject.Title }} Students</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="!confirming" class="modal-body">
          <form @submit.prevent="saveStudents">
            <div
              v-for="student in AllStudents.slice().sort($orderByName)"
              :key="student.Student_Id"
              class="form-group form-check"
            >
              <input
                type="checkbox"
                class="form-check-input"
                v-bind:id="student.Student_Id"
                v-bind:value="student.Student_Id"
                v-model="selectedStudents"
                @change="checkStudent(student.Student_Id, $event)"
              />
              <label class="form-check-label" v-bind:for="student.Student_Id">{{
                student.Name
              }}</label>
              <div
                v-for="unit in Subject.Units"
                :key="unit.Unit_Id"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="student.Student_Id + 'unit' + unit.Unit_Id"
                  v-bind:value="unit.Unit_Id"
                  v-model="studentUnits[student.Student_Id]"
                  @change="checkUnit(student.Student_Id, $event)"
                />
                <label
                  class="form-check-label"
                  v-bind:for="student.Student_Id + 'unit' + unit.Unit_Id"
                  >{{ unit.Title }}</label
                >
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
        <div v-if="confirming" class="modal-body text-left">
          <p v-if="studentsToRemove.length > 0">
            The following students will have all their data for
            {{ Subject.Title }} archived and it will no longer appear by
            default.
          </p>
          <p
            v-for="student in studentsToRemove"
            :key="'studentToRemove' + student.studentId"
          >
            {{ AllStudents.find(s => s.Student_Id == student.studentId).Name }}
          </p>
          <p v-if="studentUnitsToRemove.length > 0">
            The following students will have their data for the designated
            unit(s) archived and will no longer appear by default.
          </p>
          <div
            class="mb-2"
            v-for="studentUnits in studentUnitsToRemove"
            :key="studentUnits.student.Student_Id"
          >
            <p class="mb-0">{{ studentUnits.student.Name }}:</p>
            <p
              class="mb-0 ml-2"
              v-for="unit in studentUnits.unitIds"
              :key="unit"
            >
              {{ Subject.Units.find(u => u.Unit_Id == unit).Title }}
            </p>
          </div>
          <p>Are you sure you want to do this?</p>
          <div class="row">
            <div class="col-auto">
              <button
                type="button"
                v-on:click="cancelConfirm"
                class="btn btn-danger"
              >
                Cancel
              </button>
            </div>
            <div class="col" />
            <div class="col-auto">
              <button
                type="button"
                v-on:click="updateSubjectStudents"
                class="btn btn-primary"
              >
                Archive Student Data
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "ManageSubjectStudentsModal",
  props: {
    AllStudents: Array,
    Subject: Object
  },
  data() {
    return {
      originalStudents: [],
      selectedStudents: [],
      studentsToRemove: [],
      studentUnitsToRemove: [],
      originalStudentUnits: [],
      studentUnits: [],
      confirming: false
    };
  },
  watch: {
    Subject: function() {
      if (this.Subject != null) {
        if (this.confirming) {
          this.cancelConfirm();
        }
        var unitIds = this.Subject.Units.map(u => u.Unit_Id);
        this.selectedStudents = [];
        this.originalStudents = [];
        this.studentUnits = [];
        this.originalStudentUnits = [];
        this.AllStudents.forEach(student => {
          if (
            student.Subjects.map(s => s.Subject_Id).includes(
              this.Subject.Subject_Id.toString()
            )
          ) {
            this.selectedStudents.push(student.Student_Id);
            this.originalStudents.push(student.Student_Id);
          }
          var units = student.Units.filter(u => unitIds.includes(u.Unit_Id));
          if (units.length > 0) {
            this.studentUnits[student.Student_Id] = units.map(u => u.Unit_Id);
            this.originalStudentUnits[student.Student_Id] = units.map(
              u => u.Unit_Id
            );
          } else {
            this.studentUnits[student.Student_Id] = [];
            this.originalStudentUnits[student.Student_Id] = [];
          }
        });
      }
    }
  },
  mounted() {},
  methods: {
    async saveStudents() {
      //if there are no students originally in the subject, there are no students to remove.
      this.studentsToRemove = [];
      if (this.originalStudents.length > 0) {
        var newStudentsToRemove = this.originalStudents.filter(
          s => !this.selectedStudents.includes(s)
        );
        newStudentsToRemove.forEach(studentId => {
          this.studentsToRemove.push({
            studentId: studentId,
            subjectIds: [this.Subject.Subject_Id]
          });
        });
      }
      this.studentUnitsToRemove = [];
      //if there are no students originally in the unit there are no student units to remove.
      if (this.originalStudentUnits.length > 0) {
        this.AllStudents.forEach(student => {
          //if the student is not part of the original units, there are no student units to remove
          if (this.originalStudentUnits[student.Student_Id]) {
            var removedUnits = this.originalStudentUnits[
              student.Student_Id
            ].filter(
              //if the student was in the original student units then it would be in the student units now,
              //so we find the units that were in the original but are not in the current list of student units
              u => !this.studentUnits[student.Student_Id].includes(u)
            );
            //if there are any units to be removed we add them to the studentUnitsToRemove
            if (removedUnits.length > 0) {
              this.studentUnitsToRemove.push({
                student: student,
                unitIds: removedUnits
              });
            }
          }
        });
      }

      if (
        this.studentsToRemove.length > 0 ||
        this.studentUnitsToRemove.length > 0
      ) {
        this.confirming = true;
      } else {
        await this.updateSubjectStudents();
      }
    },
    async updateSubjectStudents() {
      this.$store.commit("updateLoading", true);
      $("#manageSubjectStudentsModal").modal("hide");
      await this.addStudents().then(async () => {
        await this.removeStudents().then(() => {
          this.confirming = false;
          this.$emit("updated-subject-students", this.Subject.Subject_Id);
        });
      });
    },
    async addStudents() {
      var newSelectedStudents = this.selectedStudents.filter(
        s => !this.originalStudents.includes(s)
      );
      var studentsToAdd = [];
      newSelectedStudents.forEach(studentId => {
        studentsToAdd.push({
          studentId: studentId,
          subjectIds: [this.Subject.Subject_Id]
        });
      });

      var studentUnitsToAdd = [];
      this.AllStudents.forEach(student => {
        //if the studentUnits does not have the student
        if (this.studentUnits[student.Student_Id]) {
          var addedUnits = this.studentUnits[student.Student_Id].filter(
            u => !this.originalStudentUnits[student.Student_Id].includes(u)
          );
          if (addedUnits.length > 0) {
            studentUnitsToAdd.push({
              studentId: student.Student_Id,
              unitIds: addedUnits
            });
          }
        }
      });

      await this.$createStudentSubjectsPairs(studentsToAdd).then(async () => {
        this.$createStudentUnitsPairs(studentUnitsToAdd).then(() => {
          return;
        });
      });
    },
    async removeStudents() {
      await this.$archiveStudentUnitsPairs(this.studentUnitsToRemove).then(
        async () => {
          await this.$archiveStudentSubjectsPairs(this.studentsToRemove).then(
            () => {
              return;
            }
          );
        }
      );
    },
    cancelConfirm() {
      console.log("cancel confirm");
      this.confirming = false;
    },
    checkUnit(studentId, event) {
      if (event.target.checked && !this.selectedStudents.includes(studentId)) {
        this.selectedStudents.push(studentId);
      }
    },
    checkStudent(studentId, event) {
      if (!event.target.checked) {
        this.studentUnits[studentId] = [];
      }
    }
  }
};
</script>
